import { FC } from 'react';
import { Stack } from '@mantine/core';
import Subtitle from 'components/Subtitle';
import FieldTextArea from './FieldTextArea';

const Feedback: FC = () => {
    return (
        <>
            <Subtitle title="Palaute" />
            <p>Vapaa sana, toivomuksia tuleviin laneihin, palautetta Tammilaneista 2025</p>
            <Stack>
                <FieldTextArea name="feedback" title="" placeholder="Anna runosuonen kukkia" />
            </Stack>
        </>
    );
};

export default Feedback;
